import { UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { Geokoordinaten } from '../../../../domain/model/geokoordinaten.model';
import { ControlConfig } from '../../form-config.model';
import { Geokoordinatensystem } from '../../../../domain/model/geokoordinatensystem.enum';
import { UTMGeokoordinatenValidator } from './utm-geokoordinaten-validator';
import { DezimalgradGeokoordinatenValidator } from './dezimalgrad-geokoordinaten-validator';

export class GeokoordinatenValidator {

    static validate(formGroup: UntypedFormGroup): ValidationErrors | null {
        const controls = formGroup.controls as ControlConfig<Geokoordinaten>;
        const errors = new Map();

        if (controls.geokoordinatenSystem.value === Geokoordinatensystem.UTM) {
            if (!controls.zone.value || (controls.zone.value != 32 && controls.zone.value != 33)) {
                controls.zone.setErrors({ zone: true });
                errors.set('invalidZone', true);
            }

            if (!GeokoordinatenValidator.isPositiveFloat(controls.hochwert.value)) {
                errors.set('invalidHochwert', true);
                controls.hochwert.setErrors({ invalidHochwert: true });
            }

            const hochwertValidation = UTMGeokoordinatenValidator.validateHochwert(controls.hochwert.value, controls.zone.value);

            if (hochwertValidation && hochwertValidation[UTMGeokoordinatenValidator.ERROR_KEY_HOCHWERT_OUT_OF_BOUNDS]) {
                errors.set('invalidHochwertOoB', true);
                controls.hochwert.setErrors({ invalidHochwertOoB: true });
            }

            if (hochwertValidation && hochwertValidation[UTMGeokoordinatenValidator.ERROR_KEY_INVALID_PATTERN]) {
                errors.set('invalidHochwertPattern', true);
                controls.hochwert.setErrors({ invalidHochwertPattern: true });
            }

            if (!GeokoordinatenValidator.isPositiveFloat(controls.rechtswert.value)) {
                errors.set('invalidRechtswert', true);
                controls.rechtswert.setErrors({ invalidRechtswertOoB: true });
            }

            const rechtswertValidation = UTMGeokoordinatenValidator.validateRechtswert(controls.rechtswert.value, controls.zone.value);

            if (rechtswertValidation && rechtswertValidation[UTMGeokoordinatenValidator.ERROR_KEY_INVALID_PATTERN]) {
                errors.set('invalidRechtswertPattern', true);
                controls.rechtswert.setErrors({ invalidRechtswertPattern: true });
            }

            if (rechtswertValidation && rechtswertValidation[UTMGeokoordinatenValidator.ERROR_KEY_RECHTSWERT_OUT_OF_BOUNDS]) {
                errors.set('invalidRechtswertOoB', true);
                controls.rechtswert.setErrors({ invalidRechtswertOoB: true });
            }

        } else if (controls.geokoordinatenSystem.value === Geokoordinatensystem.DEZIMALGRAD) {
            if (!GeokoordinatenValidator.isPositiveNumber(controls.latitude.value)) {
                errors.set('invalidLatitude', true);
                controls.latitude.setErrors({ invalidLatitude: true });
            } else if (DezimalgradGeokoordinatenValidator.validateLatitude(controls.latitude.value) != null) {
                errors.set('invalidLatitude', true);
                controls.latitude.setErrors({ invalidLatitude: true });
            }

            if (!GeokoordinatenValidator.isPositiveNumber(controls.longitude.value)) {
                errors.set('invalidLongitude', true);
                controls.longitude.setErrors({ invalidLongitude: true });
            } else if (DezimalgradGeokoordinatenValidator.validateLongitude(controls.longitude.value) != null) {
                errors.set('invalidLongitude', true);
                controls.longitude.setErrors({ invalidLongitude: true });
            }
        }
        return errors.size > 0 ? GeokoordinatenValidator.convertMapToObject(errors) : null;
    }

    private static isPositiveNumber(number: number): boolean {
        return Number.isFinite(number) && number > -1;
    }

    private static isPositiveFloat(number: number): boolean {
        return GeokoordinatenValidator.isPositiveNumber(number) && Number.parseFloat(number.toString()) != Number.NaN;
    }

    private static convertMapToObject(map: Map<any, any>): object {
        const obj = {};
        map.forEach((value, key) => (obj[key] = value));
        return obj;
    }
}
